import { IState } from '../../../store';
import { IAddressInfo } from '../../../types/geo/address';

export function addressSelector(state: IState): IAddressInfo[] {
  return state.offerData.offer.geo.address;
}
